export default function PageHeader({ title, subtitle, children, testid }) {
  return (
    <div className="flex flex-col gap-4 border-b border-border bg-background/60 px-6 py-6 backdrop-blur-xl sm:flex-row sm:items-center sm:justify-between md:px-8" data-testid={testid}>
      <div>
        <h1 className="font-heading text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
